import { Components, Theme } from '@mui/material';

const MuiTooltip: Components<Theme>['MuiTooltip'] = {
  styleOverrides: {
    popper: {
      zIndex: 2010,
    },

    tooltip: ({ theme }) => ({
      padding: theme.spacing(theme.spacingSizes.xs),
      fontSize: theme.fontSizes.sm,
      fontWeight: theme.typography.fontWeightMedium,
      lineHeight: '14px',
    }),
  },
};

export default MuiTooltip;
